import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { FormDirty } from "go-form/components/FormDirty";
import { ChangeUserPasswordFormProps } from "../../../../../../../../../services/Api/User/userTypes";
import { api } from "../../../../../../../../../services/Security/api";

const ChangePasswordForm = () => {
	const form = useForm<ChangeUserPasswordFormProps>({
		criteriaMode: "all",
		defaultValues: {},
	});

	const {
		register,
		handleSubmit,
		formState: { errors },
		setError,
		reset,
		formState,
	} = form;
	const [loading, setLoading] = useState(false);
	const { addFlash, addSuccessFlash } = useFlash();
	const { t } = useTranslation();

	const onSubmit = handleSubmit(async (data) => {
		setLoading(true);
		try {
			await api.user().changePassword(data);
			addSuccessFlash(t("lib:common.flash.completed"));
			reset(data);
		} catch (e) {
			handleError.form(e, setError, addFlash);
		}
		setLoading(false);
	});

	return (
		<FormDirty loading={loading} formState={formState} key="profile-form" noValidate onSubmit={onSubmit}>
			<fieldset className={"form-group no-gutters"}>
				<div className={"col-8"}>
					<FormInput
						label={t("modules.profile.field.current_password.title")}
						register={register}
						type="password"
						name="current_password"
						errors={errors}
					/>
					<FormInput
						label={t("modules.profile.field.new_password.title")}
						register={register}
						type="password"
						name="new_password"
						errors={errors}
					/>
					<FormInput
						label={t("modules.profile.field.confirm_password.title")}
						register={register}
						type="password"
						name="new_password_confirmation"
						errors={errors}
					/>
				</div>
			</fieldset>
		</FormDirty>
	);
};

export default ChangePasswordForm;
